import React, { Component } from "react";
import { Router, Route, Switch, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import ReactGA from "react-ga";

import "./stylesheets/ionicons.min.css";
import "./stylesheets/mci.css";
import "./stylesheets/mci-responsive.css";
import Landing from "./pages/Landing";
import Quote from "./pages/Quote";
import About from "./pages/About";
import Compare from "./pages/Compare";
import BuyInsurance from "./pages/BuyInsurance";
import Login from "./pages/auth/Login";
import Resources from "./pages/Resources";
import FileClaim from "./pages/FileClaim";
import FileClaims from "./pages/dashboard/policies/FileClaim";
import PolicyVerification from "./pages/PolicyVerification";
import PageNotFound from "./pages/PageNotFound";
import FAQs from "./pages/FAQs";
import ContactUs from "./pages/ContactUs";
import Dashboard from "./pages/user/Dashboard";
import Policies from "./pages/dashboard/policies/Policies";
import PendingQuotes from "./pages/dashboard/policies/PendingQuotes";
import Commissions from "./pages/dashboard/policies/Commissions";
import Claims from "./pages/dashboard/policies/Claims";
import Certificates from "./pages/dashboard/policies/Certificates";
import OpenCover from "./pages/dashboard/policies/OpenCover";
import PolicyDocument from "./pages/dashboard/policies/PolicyDocument";
import VerifyPolicy from "./pages/dashboard/policies/VerifyPolicy";
import ReceivedPayments from "./pages/dashboard/payments/ReceivedPayments";
import CreditManagement from "./pages/dashboard/payments/CreditManagement";
import GoodsRates from "./pages/dashboard/rates/GoodsRates";
import OtherRates from "./pages/dashboard/rates/OtherRates";
import Limits from "./pages/dashboard/rates/Limits";
import Discounts from "./pages/dashboard/rates/Discounts";
import Branches from "./pages/dashboard/agents/Branches";
import Agents from "./pages/dashboard/agents/Agents";
import ClearingAgents from "./pages/dashboard/agents/ClearingAgents";
import BrokersAgencies from "./pages/dashboard/agents/BrokersAgencies";
import PremiumDeposit from "./pages/dashboard/agents/PremiumDeposit";
import Bancassurance from "./pages/dashboard/agents/Bancassurance";
import Reports from "./pages/dashboard/Reports";
import Revenue from "./pages/dashboard/Revenue";
import Regions from "./pages/dashboard/Regions";
import Flagged from "./pages/dashboard/Flagged";
import UploadPolicies from "./pages/dashboard/UploadPolicies";
import CurrencyRates from "./pages/dashboard/rates/CurrencyRates";
import Users from "./pages/dashboard/Users";
import UsersPermissions from "./pages/dashboard/UsersPermissions";
import Profile from "./pages/user/Profile";
import Settings from "./pages/user/Settings";
import Insurers from "./pages/dashboard/insurers/Insurers";
import Expired from "./pages/dashboard/policies/Expired";
import Qoutes from "./pages/QoutesPagination";

// import { initJivoChat } from './utils/jivochat.js';
import { translations } from "./i18n/translations";
import history from "./utils/history";

import userRoles from "./utils/user-roles";
import { getCurrentUser } from "./utils/user-utils";

ReactGA.initialize("UA-112408851-1");

class AppRouter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.user
    };
  }

  componentDidMount() {
    if (window.location.hostname !== "localhost") {
      // initJivoChat();
      this.trackPageView();
      history.listen(() => {
        this.trackPageView();
      });
    }
  }

  trackPageView() {
    ReactGA.pageview(window.location.pathname);
  }

  authorize = (allowedRoles, page) => {
    const { user } = this.state;

    const thisUser = getCurrentUser(user);

    if (thisUser) {
      let role = thisUser.role;

      if (role && allowedRoles.includes(role)) {
        return page;
      } else {
        return Login;
      }
    }
  };

  render() {
    return (
      <Router history={history}>
        <div className="App">
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route path="/quote" component={Quote} />
            <Route path="/about" component={About} />
            <Route path="/compare" component={Compare} />
            <Route path="/buy/:id" component={BuyInsurance} />
            <Route path="/login-register" component={Login} />

            <Route path="/file-claim" component={FileClaim} />
            <Route path="/verify-policy" component={PolicyVerification} />
            <Route path="/faqs" component={FAQs} />
            <Route path="/contact-us" component={ContactUs} />
            <Route path="/dashboard" component={Dashboard} />
            <Route
              path="/uploads"
              component={this.authorize(userRoles.superAdmins, UploadPolicies)}
            />
            <Route
              path="/insurers"
              component={this.authorize(userRoles.sinbadAdmins, Insurers)}
            />
            <Route
              path="/policies"
              component={this.authorize(userRoles.superAdmins, Policies)}
            />
            <Route path="/certificates" component={Certificates} />
            <Route path="/pending-quotes" component={PendingQuotes} />
            <Route path="/resources" component={Resources} />
            <Route
              path="/claims"
              component={this.authorize(userRoles.superAdmins, Claims)}
            />
            <Route
              path="/fileclaims"
              component={this.authorize(userRoles.agentsOnly, FileClaims)}
            />
            <Route path="/policy-document" component={PolicyDocument} />
            <Route path="/policy-verification" component={VerifyPolicy} />
            <Route path="/expired" component={Expired} />

            <Route path="/revenue" component={Revenue} />
            <Route
              path="/commissions"
              component={this.authorize(userRoles.superAdmins, Commissions)}
            />
            <Route
              path="/received-payments"
              component={this.authorize(
                userRoles.superAdmins,
                ReceivedPayments
              )}
            />
            <Route path="/credit-management" component={CreditManagement} />
            <Route path="/regions" component={Regions} />
            <Route path="/branches" component={Branches} />
            <Route path="/open-covers" component={OpenCover} />
            <Route path="/currency-rates" component={CurrencyRates} />
            <Route path="/discounts" component={Discounts} />
            <Route path="/goods-rates" component={GoodsRates} />
            <Route path="/other-rates" component={OtherRates} />
            <Route path="/limits" component={Limits} />
            <Route path="/qoutes" component={Qoutes} />
            <Route path="/brokers-agencies" component={BrokersAgencies} />
            <Route path="/premium-deposist" component={PremiumDeposit} />
            <Route path="/bancassurance" component={Bancassurance} />
            <Route path="/agents" component={Agents} />
            <Route path="/clearing-agents" component={ClearingAgents} />

            <Route
              path="/flagged"
              component={this.authorize(userRoles.superAdmins, Flagged)}
            />

            <Route
              path="/users"
              component={this.authorize(userRoles.sinbadAdmins, Users)}
            />
            <Route
              path="/users-permissions"
              component={this.authorize(
                userRoles.superAdmins,
                UsersPermissions
              )}
            />

            <Route path="/profile" component={Profile} />
            <Route path="/reports" component={Reports} />
            <Route path="/settings" component={Settings} />

            <Route component={PageNotFound} />
          </Switch>

          <div className="footer">
            <div className="container">
              &copy; {translations.mci_portal}
              <span className="pull-right">
                <NavLink activeClassName="active" to="/">
                  {translations.home}
                </NavLink>
                <NavLink activeClassName="active" to="/about">
                  {translations.about}
                </NavLink>
              </span>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  user: state.user
});
export default connect(mapStateToProps, null)(AppRouter);



// WEBPACK FOOTER //
// ./src/App.js